import { render, staticRenderFns } from "./FormAdministrative.vue?vue&type=template&id=424cce2c&scoped=true&"
import script from "./FormAdministrative.vue?vue&type=script&lang=js&"
export * from "./FormAdministrative.vue?vue&type=script&lang=js&"
import style0 from "./FormAdministrative.vue?vue&type=style&index=0&id=424cce2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424cce2c",
  null
  
)

export default component.exports